module.exports = __webpack_public_path__ + "img/Backed-By-SBLI.cb4efefa.svg";